import { inject } from '@angular/core';
import { DateHelper } from '@shared/helpers';
import { CourseApiService } from '@shared/services';
import { CourseType } from '@shared/enums/course.enum';
import { TableConfig, PLACEHOLDER_FUNCTIONS } from '../generic-p-table.interfaces';

export const tutorTableConfig = (): TableConfig => {
    const courseApiService = inject(CourseApiService);

    return {
        title: 'Quản lý Gia sư',
        entityName: 'gia sư',
        service: courseApiService,
        method: 'getCourses',
        additionalParams: {
            query: {
                type: CourseType.TUTOR
            }
        },
        transformResponse: (response: any) => {
            // Transform schedules to scheduleText for display
            if (response && response.data.items) {
                response.data.items = response.data.items.map((item: any) => ({
                    ...item,
                    scheduleText: DateHelper.formatSchedulesToText(item.schedules)
                }));
            }
            return response;
        },
        columns: [
            { field: 'code', header: 'Mã khóa học', width: 'min-w-[150px]', sortable: true, type: 'text' },
            { field: 'name', header: 'Tên khóa học', width: 'min-w-[150px]', sortable: true, type: 'text' },
            { field: 'fromDate', header: 'Ngày bắt đầu', width: 'min-w-[120px]', sortable: true, type: 'date' },
            { field: 'toDate', header: 'Ngày kết thúc', width: 'min-w-[120px]', sortable: true, type: 'date' },
            { field: 'courseLevel.name', header: 'Cấp độ', width: 'min-w-[120px]', sortable: false, type: 'tag', tagColor: 'courseLevel.tagColor', tagTextColor: 'courseLevel.tagTextColor' },
            { field: 'scheduleText', header: 'Lịch học', width: 'min-w-[150px]', sortable: false, type: 'text', styleClass: 'flex text-right whitespace-pre-line' },
            { field: 'numHours', header: 'Số giờ', width: 'min-w-[100px]', sortable: true, type: 'text' },
            { field: 'ta.profile.nickname', header: 'Trợ giảng', width: 'min-w-[150px]', sortable: false, type: 'text' },
            { field: 'room.code', header: 'Phòng', width: 'min-w-[100px]', sortable: true, type: 'tag', tagColor: 'room.tagColor', tagTextColor: 'room.tagTextColor' },
            { field: 'roomSec.code', header: 'Phòng phụ', width: 'min-w-[100px]', sortable: true, type: 'tag', tagColor: 'roomSec.tagColor', tagTextColor: 'roomSec.tagTextColor' },
            { field: 'hostAcc.name', header: 'Acc Host', width: 'min-w-[100px]', sortable: true, type: 'text' },
            { field: 'status', header: 'Trạng thái', width: 'min-w-[150px]', sortable: true, type: 'tag', tagType: 'courseStatus' }
        ],
        features: {
            virtualScroll: true,
            toolbar: true
        },
        actions: [
            {
                location: 'toolbar',
                useDefaultStyle: 'add',
                onClick: PLACEHOLDER_FUNCTIONS.OPEN_NEW
            },
            {
                location: 'row',
                useDefaultStyle: 'edit',
                onClick: PLACEHOLDER_FUNCTIONS.EDIT
            }
        ]
    };
};

